

































































































































import moment from 'moment';
import DictMixin from '@/mixins/dict-mixin';
import { BatchJobInfo } from '@/services/datacollect';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class DatacollectForm5 extends mixins(DictMixin) {
  @PropSync('batchInfoDefs') syncBatchInfoDefs!: BatchJobInfo;

  time = moment('00:00:00', 'HH:mm:ss');
  date = moment();
  type = 0;
  weekday = '1';
  day = 1;
  season = 0;

  syncType = ['增量采集', '全量采集'];
  cleanType = ['写入前保留已有数据', '写入前清理已有数据'];
  incrementType = ['自增主键', '时间', 'HIVE分区'];
  dataDurationList = ['T','T+1','T+2','T+3'];

  created() {
    this.onSyncBatchInfoDefsChange();
  }

  @Watch('syncBatchInfoDefs')
  onSyncBatchInfoDefsChange() {
    if (this.syncBatchInfoDefs.runDateStr ) {
      this.date = moment(this.syncBatchInfoDefs.runDateStr, 'YYYY-MM-DD');
    }
    if (this.syncBatchInfoDefs.runTimeStr) {
      this.time = moment(this.syncBatchInfoDefs.runTimeStr, 'HH:mm:ss');
    } else {
      this.time = moment('00:00:00', 'HH:mm:ss');
    }
    this.type = this.syncBatchInfoDefs.rate || 0;
    this.day = this.syncBatchInfoDefs.day || 1;
    this.weekday = this.syncBatchInfoDefs.weekday || '1';
    this.season = this.syncBatchInfoDefs.season || 0;
    this.syncBatchInfoDefs.failRetryCount = this.syncBatchInfoDefs.failRetryCount ?? 3;
    this.syncBatchInfoDefs.failTimeout = this.syncBatchInfoDefs.failTimeout ?? 30;
 
    this.changeCron();
  }

  changeCron() {
    debugger
    let year = moment(this.date).format('Y');
    let month = moment(this.date).format('M');
    let day = moment(this.date).format('D');
    let hour = moment(this.time).hour();
    let minute = moment(this.time).minute();
    let second = moment(this.time).second();
    let cron = '';
    if (this.syncBatchInfoDefs.triggerMode == 1) {
      cron = `${second} ${minute} ${hour} ${day} ${month} ? ${year}`;
    }
    if (this.syncBatchInfoDefs.triggerMode == 2) {
      // 每天
      this.type == 0 && (cron = `${second} ${minute} ${hour} * * ?`);
      // 每小时
      this.type == 1 && (cron = `${second} ${minute} * * * ?`);
      // 每周
      this.type == 2 && (cron = `${second} ${minute} ${hour} * * ${this.weekday} ?`);
      // 每月
      this.type == 3 && (cron = `${second} ${minute} ${hour} ${this.day} * ?`);
      // 每季
      if (this.type == 4) {
        let month = '1,4,7,10';
        let d: any = '1';
        if (this.season === 1) {
          month = '3,6,9,12';
          d = 'L';
        }
        this.season === 2 && (d = this.day);
        cron = `${second} ${minute} ${hour} ${d} ${month} ?`;
      }
      // 每年
      this.type == 5 && (cron = `${second} ${minute} ${hour} ${day} ${month} ?`);
    }

    this.syncBatchInfoDefs.cronExpression = cron;
    this.syncBatchInfoDefs.rate = this.type;
    this.syncBatchInfoDefs.day = this.day;
    this.syncBatchInfoDefs.weekday = this.weekday;
    this.syncBatchInfoDefs.season = this.season;
    this.syncBatchInfoDefs.runDateStr = moment(this.date).format('YYYY-MM-DD');
    this.syncBatchInfoDefs.runTimeStr =  moment(this.time).format('HH:mm:ss');
  }
}
